export default String.raw`
@media screen and (max-width: 499px) {
    .mblist {
        &-wrapper {
            grid-template-columns: 45% 45%;
        }
    }
}
`